(() => {
  const STORAGE_PREFIX = 'marketnow-grouped-offers:';

  function initAll(scope = document) {
    scope.querySelectorAll('[data-grouped-offers]').forEach(initGroupedOffers);
  }

  function initGroupedOffers(root) {
    if (
      !(root instanceof HTMLElement) ||
      root.dataset.groupedOffersReady === 'true'
    ) {
      return;
    }

    const configScript = root.querySelector(
      '[data-grouped-offers-config]'
    );
    const productDialog = root.querySelector(
      '[data-grouped-product-dialog]'
    );
    const productDialogContent = root.querySelector(
      '[data-grouped-product-dialog-content]'
    );
    const selectionDialog = root.querySelector(
      '[data-grouped-selection-dialog]'
    );
    const selectionItems = root.querySelector(
      '[data-grouped-selection-items]'
    );
    const productGrid = root.querySelector(
      '[data-grouped-grid]'
    );

    const infiniteSentinel = root.querySelector(
      '[data-grouped-infinite-sentinel]'
    );

    const infiniteStatus = root.querySelector(
      '[data-grouped-infinite-status]'
    );

    if (
      !configScript ||
      !productDialog ||
      !productDialogContent ||
      !selectionDialog ||
      !selectionItems ||
      !productGrid ||
      !infiniteSentinel ||
      !infiniteStatus
    ) {
    console.error('Offres groupées : certains éléments nécessaires sont introuvables.', {
        configScript,
        productDialog,
        productDialogContent,
        selectionDialog,
        selectionItems,
    });

    return;
    }
    const config = parseJSON(configScript.textContent, {});
    const products = new Map();

    registerProducts(root);

    const storageKey =
      `${STORAGE_PREFIX}${config.collectionUrl || location.pathname}`;

    const state = {
      items: loadItems(storageKey),
    };

    let activeProduct = null;
    let activeVariant = null;
    let activeOptions = [];
    let activeQuantity = 1;

    root.dataset.groupedOffersReady = 'true';
    root.addEventListener('click', onRootClick);

    [productDialog, selectionDialog].forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeDialog(dialog);
        }
      });
    });
    
    renderAll();
    initInfiniteProducts();    
    function registerProducts(scope) {
      if (
        !scope ||
        typeof scope.querySelectorAll !== 'function'
      ) {
        return;
      }

      scope
        .querySelectorAll('[data-grouped-product-json]')
        .forEach((script) => {
          const product = parseJSON(
            script.textContent,
            null
          );

          if (product?.id) {
            products.set(
              String(product.id),
              product
            );
          }
        });
    }

    function shuffleArray(items) {
      const shuffledItems = [...items];

      for (
        let currentIndex = shuffledItems.length - 1;
        currentIndex > 0;
        currentIndex -= 1
      ) {
        const randomIndex = Math.floor(
          Math.random() * (currentIndex + 1)
        );

        [
          shuffledItems[currentIndex],
          shuffledItems[randomIndex],
        ] = [
          shuffledItems[randomIndex],
          shuffledItems[currentIndex],
        ];
      }

      return shuffledItems;
    }

    function buildRandomPageQueue(
      totalPages,
      excludedPage = null
    ) {
      const pages = [];

      for (
        let pageNumber = 1;
        pageNumber <= totalPages;
        pageNumber += 1
      ) {
        if (pageNumber !== excludedPage) {
          pages.push(pageNumber);
        }
      }

      return shuffleArray(pages);
    }

    function setInfiniteStatus(
      message = '',
      isLoading = false
    ) {
      if (!(infiniteStatus instanceof HTMLElement)) {
        return;
      }

      infiniteStatus.textContent = message;

      infiniteStatus.classList.toggle(
        'is-loading',
        isLoading
      );

      infiniteStatus.hidden = message === '';
    }

    function initInfiniteProducts() {
      const initialPage = Math.max(
        1,
        Number.parseInt(
          productGrid.dataset.currentPage || '1',
          10
        ) || 1
      );

      const totalPages = Math.max(
        1,
        Number.parseInt(
          productGrid.dataset.totalPages || '1',
          10
        ) || 1
      );

      let pageQueue = buildRandomPageQueue(
        totalPages,
        initialPage
      );

      let loading = false;

      const initialCards = Array.from(
        productGrid.children
      ).filter(
        (element) =>
          element instanceof HTMLElement &&
          element.matches('[data-grouped-product]')
      );

      shuffleArray(initialCards).forEach((card) => {
        productGrid.appendChild(card);
      });

      async function loadMoreProducts() {
        if (loading) {
          return;
        }

        /*
        * Lorsque toutes les pages ont été affichées,
        * un nouveau cycle aléatoire commence.
        */
        if (pageQueue.length === 0) {
          pageQueue = buildRandomPageQueue(
            totalPages
          );
        }

        const nextPage = pageQueue.shift();

        if (!nextPage) {
          return;
        }

        loading = true;

        setInfiniteStatus(
          'Chargement de nouveaux produits…',
          true
        );

        try {
          const requestUrl = new URL(
            window.location.href
          );

          requestUrl.searchParams.set(
            'page',
            String(nextPage)
          );

          const response = await fetch(
            requestUrl.toString(),
            {
              credentials: 'same-origin',
              headers: {
                'X-Requested-With':
                  'XMLHttpRequest',
              },
            }
          );

          if (!response.ok) {
            throw new Error(
              `Erreur HTTP ${response.status}`
            );
          }

          const html = await response.text();

          const parser = new DOMParser();

          const incomingDocument =
            parser.parseFromString(
              html,
              'text/html'
            );

          const incomingRoot =
            incomingDocument.getElementById(
              root.id
            ) ||
            incomingDocument.querySelector(
              '[data-grouped-offers]'
            );

          const incomingGrid =
            incomingRoot?.querySelector(
              '[data-grouped-grid]'
            );

          if (!incomingGrid) {
            throw new Error(
              'La grille de produits est introuvable.'
            );
          }

          const incomingCards = Array.from(
            incomingGrid.children
          ).filter(
            (element) =>
              element instanceof HTMLElement &&
              element.matches(
                '[data-grouped-product]'
              )
          );

          if (incomingCards.length === 0) {
            throw new Error(
              'Aucun produit reçu.'
            );
          }

          const shuffledCards =
            shuffleArray(incomingCards);

          const fragment =
            document.createDocumentFragment();

          shuffledCards.forEach((card) => {
            const clonedCard =
              card.cloneNode(true);

            registerProducts(clonedCard);

            fragment.appendChild(clonedCard);
          });

          productGrid.appendChild(fragment);

          /*
          * Met à jour les badges de quantité sur
          * les nouvelles cartes.
          */
          renderCards();

          setInfiniteStatus('');
        } catch (error) {
          console.error(
            'Offres groupées — chargement infini :',
            error
          );

          /*
          * Remet la page dans la file pour pouvoir
          * réessayer plus tard.
          */
          pageQueue.unshift(nextPage);

          setInfiniteStatus(
            'Le chargement a échoué. Nouvelle tentative…'
          );

          window.setTimeout(() => {
            loadMoreProducts();
          }, 2500);
        } finally {
          loading = false;
        }
      }

      const infiniteObserver =
        new IntersectionObserver(
          (entries) => {
            const sentinelIsVisible =
              entries.some(
                (entry) => entry.isIntersecting
              );

            if (sentinelIsVisible) {
              loadMoreProducts();
            }
          },
          {
            root: null,
            rootMargin: '700px 0px',
            threshold: 0,
          }
        );

      infiniteObserver.observe(
        infiniteSentinel
      );
    }
    function onRootClick(event) {
      if (!(event.target instanceof Element)) return;

      const openProduct = event.target.closest(
        '[data-grouped-open-product]'
      );

      if (openProduct) {
        openProductDialog(openProduct.dataset.productId || '');
        return;
      }

      const closeButton = event.target.closest(
        '[data-grouped-close-dialog]'
      );

      if (closeButton) {
        const dialog = closeButton.closest('dialog');

        if (dialog) {
          closeDialog(dialog);
        }

        return;
      }

      if (
        event.target.closest(
          '[data-grouped-open-selection], [data-grouped-open-selection-action]'
        )
      ) {
        renderSelection();
        showDialog(selectionDialog);
        return;
      }

      const optionButton = event.target.closest(
        '[data-grouped-option-index]'
      );

      if (optionButton instanceof HTMLButtonElement) {
        chooseOption(
          Number(optionButton.dataset.groupedOptionIndex),
          optionButton.dataset.groupedOptionValue || ''
        );

        return;
      }

      const modalQuantityButton = event.target.closest(
        '[data-grouped-modal-quantity-change]'
      );

      if (modalQuantityButton instanceof HTMLButtonElement) {
        const change = Number(
          modalQuantityButton.dataset.groupedModalQuantityChange || 0
        );

        activeQuantity = clamp(activeQuantity + change, 1, 99);
        renderProductDialog();
        return;
      }

      if (event.target.closest('[data-grouped-confirm-product]')) {
        confirmProduct();
        return;
      }

      const lineAction = event.target.closest(
        '[data-grouped-line-action]'
      );

      if (lineAction instanceof HTMLElement) {
        updateLine(
          lineAction.dataset.variantId || '',
          lineAction.dataset.groupedLineAction || ''
        );

        return;
      }

      if (event.target.closest('[data-grouped-whatsapp]')) {
        sendWhatsApp();
      }
    }

    function openProductDialog(productId) {
      const product = products.get(String(productId));

      if (!product?.available) return;

      activeProduct = product;

      const existingLine = state.items.find(
        (item) => String(item.productId) === String(product.id)
      );

      const existingVariant = existingLine
        ? product.variants.find(
            (variant) =>
              String(variant.id) === String(existingLine.variantId)
          )
        : null;

      activeVariant =
        existingVariant ||
        product.variants.find((variant) => variant.available) ||
        null;

      activeOptions = activeVariant?.options
        ? [...activeVariant.options]
        : [];

      activeQuantity =
        existingLine &&
        activeVariant &&
        String(existingLine.variantId) === String(activeVariant.id)
          ? clamp(Number(existingLine.quantity) || 1, 1, 99)
          : 1;

      renderProductDialog();
      showDialog(productDialog);
    }    
    function normalizeOptionName(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();
    }

    function getColorOptionIndex(product) {
      if (!product || !Array.isArray(product.options)) {
        return -1;
      }

      return product.options.findIndex((optionName) => {
        const normalizedName = normalizeOptionName(optionName);

        return (
          normalizedName === 'couleur' ||
          normalizedName === 'color' ||
          normalizedName === 'coloris'
        );
      });
    }

    function getImageNumberFromColor(value) {
      const match = String(value || '').match(/\d+/);

      if (!match) {
        return null;
      }

      const imageNumber = Number.parseInt(match[0], 10);

      return Number.isInteger(imageNumber) && imageNumber > 0
        ? imageNumber
        : null;
    }

    function getActiveProductImage() {
      if (!activeProduct) {
        return '';
      }

      const productImages = Array.isArray(activeProduct.images)
        ? activeProduct.images.filter(Boolean)
        : [];

      const colorOptionIndex = getColorOptionIndex(activeProduct);

      if (colorOptionIndex >= 0) {
        const selectedColorValue =
          activeOptions[colorOptionIndex] || '';

        const imageNumber =
          getImageNumberFromColor(selectedColorValue);

        if (
          imageNumber !== null &&
          productImages[imageNumber - 1]
        ) {
          return productImages[imageNumber - 1];
        }
      }

      return (
        activeVariant?.image ||
        activeProduct.image ||
        productImages[0] ||
        ''
      );
    }

    function renderProductDialog() {
      if (!activeProduct) return;

      const image = getActiveProductImage();
      const price = Number(activeVariant?.price || 0);
      const compareAt = Number(
        activeVariant?.compareAtPrice || 0
      );

      const hasOptions = !(
        activeProduct.options?.length === 1 &&
        activeProduct.options[0] === 'Title' &&
        activeProduct.variants?.length === 1
      );

      const optionGroups = hasOptions
        ? activeProduct.options
            .map((optionName, optionIndex) => {
              const values = unique(
                activeProduct.variants
                  .map(
                    (variant) =>
                      variant.options?.[optionIndex]
                  )
                  .filter(Boolean)
              );

              return `
                <div class="grouped-offers-product__option-group">
                  <div class="grouped-offers-product__option-heading">
                    <span>${escapeHTML(optionName)}</span>
                    <strong>
                      ${escapeHTML(activeOptions[optionIndex] || '')}
                    </strong>
                  </div>

                  <div class="grouped-offers-product__options">
                    ${values
                      .map((value) => {
                        const selected =
                          activeOptions[optionIndex] === value;

                        const available =
                          optionIsAvailable(optionIndex, value);

                        return `
                          <button
                            type="button"
                            class="grouped-offers-product__option${
                              selected ? ' is-selected' : ''
                            }"
                            data-grouped-option-index="${optionIndex}"
                            data-grouped-option-value="${escapeHTML(value)}"
                            aria-pressed="${selected}"
                            ${available ? '' : 'disabled'}
                          >
                            ${escapeHTML(value)}
                          </button>
                        `;
                      })
                      .join('')}
                  </div>
                </div>
              `;
            })
            .join('')
        : '';

      productDialogContent.innerHTML = `
        <div class="grouped-offers-product">
          <div class="grouped-offers-product__top">
            <div class="grouped-offers-product__media">
              ${
                image
                  ? `
                    <img
                      src="${escapeHTML(image)}"
                      alt="${escapeHTML(activeProduct.title)}"
                    >
                  `
                  : `
                    <div
                      class="grouped-offers-product__image-placeholder"
                    ></div>
                  `
              }
            </div>

            <div class="grouped-offers-product__summary">
              <h2>
                ${escapeHTML(activeProduct.title)}
              </h2>

              <div class="grouped-offers-product__price">
                <strong>
                  ${formatMoney(price)}
                </strong>

                ${
                  compareAt > price
                    ? `<s>${formatMoney(compareAt)}</s>`
                    : ''
                }
              </div>

              ${
                activeVariant?.title &&
                activeVariant.title !== 'Default Title'
                  ? `<p>${escapeHTML(activeVariant.title)}</p>`
                  : ''
              }
            </div>
          </div>

          <div class="grouped-offers-product__body">
            ${optionGroups}

            <div class="grouped-offers-product__quantity-row">
              <span>Quantité</span>

              <div class="grouped-offers-product__quantity">
                <button
                  type="button"
                  data-grouped-modal-quantity-change="-1"
                  aria-label="Diminuer"
                  ${activeQuantity <= 1 ? 'disabled' : ''}
                >
                  −
                </button>

                <strong>
                  ${activeQuantity}
                </strong>

                <button
                  type="button"
                  data-grouped-modal-quantity-change="1"
                  aria-label="Augmenter"
                >
                  +
                </button>
              </div>
            </div>

            <button
              type="button"
              class="grouped-offers-product__confirm"
              data-grouped-confirm-product
              ${activeVariant?.available ? '' : 'disabled'}
            >
              ${
                activeVariant?.available
                  ? `Ajouter à ma sélection (${activeQuantity})`
                  : 'Variante indisponible'
              }
            </button>
          </div>
        </div>
      `;
    }

    function chooseOption(optionIndex, value) {
      if (!activeProduct || Number.isNaN(optionIndex)) {
        return;
      }

      const wantedOptions = [...activeOptions];
      wantedOptions[optionIndex] = value;

      let variant = activeProduct.variants.find(
        (item) =>
          item.available &&
          item.options.every(
            (option, index) =>
              option === wantedOptions[index]
          )
      );

      if (!variant) {
        variant = activeProduct.variants.find(
          (item) =>
            item.available &&
            item.options?.[optionIndex] === value
        );
      }

      if (variant) {
        activeVariant = variant;
        activeOptions = [...variant.options];

        const existingItem = state.items.find(
          (item) =>
            String(item.variantId) === String(variant.id)
        );

        activeQuantity = existingItem
          ? clamp(Number(existingItem.quantity) || 1, 1, 99)
          : 1;
      }

      renderProductDialog();
    }

    function optionIsAvailable(optionIndex, value) {
      if (!activeProduct) return false;

      const exactCombinationAvailable =
        activeProduct.variants.some((variant) => {
          if (
            !variant.available ||
            variant.options?.[optionIndex] !== value
          ) {
            return false;
          }

          return variant.options.every((option, index) => {
            if (index === optionIndex) return true;

            return (
              !activeOptions[index] ||
              option === activeOptions[index]
            );
          });
        });

      const valueAvailableInAnotherCombination =
        activeProduct.variants.some(
          (variant) =>
            variant.available &&
            variant.options?.[optionIndex] === value
        );

      return (
        exactCombinationAvailable ||
        valueAvailableInAnotherCombination
      );
    }

    function confirmProduct() {
      if (!activeProduct || !activeVariant?.available) {
        return;
      }

      const line = {
        productId: String(activeProduct.id),
        variantId: String(activeVariant.id),
        productTitle: String(activeProduct.title || ''),
        variantTitle: String(activeVariant.title || ''),
        options: Array.isArray(activeVariant.options)
          ? [...activeVariant.options]
          : [],
        image: String(getActiveProductImage()),
        price: Number(activeVariant.price || 0),
        compareAtPrice: Number(
          activeVariant.compareAtPrice || 0
        ),
        quantity: clamp(activeQuantity, 1, 99),
        url: String(activeProduct.url || ''),
      };

      const existingIndex = state.items.findIndex(
        (item) =>
          String(item.variantId) === line.variantId
      );

      if (existingIndex >= 0) {
        state.items[existingIndex] = line;
      } else {
        state.items.push(line);
      }

      saveAndRender();
      closeDialog(productDialog);
    }

    function updateLine(variantId, action) {
      const itemIndex = state.items.findIndex(
        (item) =>
          String(item.variantId) === String(variantId)
      );

      if (itemIndex < 0) return;

      if (action === 'remove') {
        state.items.splice(itemIndex, 1);
      } else if (action === 'increase') {
        state.items[itemIndex].quantity = clamp(
          Number(state.items[itemIndex].quantity) + 1,
          1,
          99
        );
      } else if (action === 'decrease') {
        const newQuantity =
          Number(state.items[itemIndex].quantity) - 1;

        if (newQuantity <= 0) {
          state.items.splice(itemIndex, 1);
        } else {
          state.items[itemIndex].quantity =
            newQuantity;
        }
      }

      saveAndRender();
    }

    function renderAll() {
      renderCards();
      renderBottomBar();

      if (selectionDialog.open) {
        renderSelection();
      }
    }

    function renderCards() {
      root
        .querySelectorAll('[data-grouped-card-quantity]')
        .forEach((badge) => {
          if (!(badge instanceof HTMLElement)) {
            return;
          }

          const productId =
            badge.dataset.groupedCardQuantity || '';

          const quantity = state.items
            .filter(
              (item) =>
                String(item.productId) === productId
            )
            .reduce(
              (sum, item) =>
                sum + Number(item.quantity || 0),
              0
            );

          badge.textContent = String(quantity);
          badge.hidden = quantity <= 0;

          const productCard = badge.closest(
            '[data-grouped-product]'
          );

          productCard?.classList.toggle(
            'is-selected',
            quantity > 0
          );
        });
    }

    function renderBottomBar() {
      const quantity = totalQuantity();
      const subtotal = getSubtotal();
      const discount = getDiscount(
        quantity,
        subtotal
      );
      const total = Math.max(
        0,
        subtotal - discount
      );

      const minimumItems = Number(
        config.minimumItems || 3
      );

      const missingItems = Math.max(
        0,
        minimumItems - quantity
      );

      const offerUnlocked = missingItems === 0;

      setText(
        '[data-grouped-progress-title]',
        quantity > 0
          ? `${quantity} article${
              quantity > 1 ? 's' : ''
            } sélectionné${
              quantity > 1 ? 's' : ''
            }`
          : 'Sélectionnez vos produits'
      );

      setText(
        '[data-grouped-progress-text]',
        offerUnlocked
          ? `Offre débloquée : ${formatMoney(
              discount
            )} de réduction`
          : `Plus que ${missingItems} article${
              missingItems > 1 ? 's' : ''
            } pour profiter de l’offre`
      );

      setText(
        '[data-grouped-bar-total]',
        formatMoney(total)
      );

      const actionButton = root.querySelector(
        '[data-grouped-open-selection-action]'
      );

      if (actionButton instanceof HTMLButtonElement) {
        actionButton.disabled = !offerUnlocked;
      }
    }

    function renderSelection() {
    const quantity = totalQuantity();
    const subtotal = getSubtotal();
    const discount = getDiscount(quantity, subtotal);
    const total = Math.max(0, subtotal - discount);

    const minimumItems = Number(config.minimumItems || 3);
    const remainingItems = Math.max(0, minimumItems - quantity);
    const offerUnlocked = quantity >= minimumItems;

    const progress = root.querySelector(
        '[data-grouped-selection-progress]'
    );

    if (progress instanceof HTMLElement) {
        progress.classList.toggle(
        'is-unlocked',
        offerUnlocked
        );

        progress.textContent = offerUnlocked
        ? `Offre débloquée : vous économisez ${formatMoney(discount)}`
        : `Plus que ${remainingItems} article${
            remainingItems > 1 ? 's' : ''
            } pour débloquer l’offre`;
    }

    if (state.items.length === 0) {
        selectionItems.innerHTML = `
        <div class="grouped-offers-selection__empty">
            <span
            class="grouped-offers-selection__empty-icon"
            aria-hidden="true"
            >
            🛍️
            </span>

            <div>
            <strong>Votre sélection est vide</strong>

            <p>
                Ajoutez des produits avec le bouton « + ».
            </p>
            </div>
        </div>
        `;
    } else {
        selectionItems.innerHTML = state.items
        .map((item) => {
            const itemVariantLabel = variantLabel(item);

            const itemQuantity =
            Number(item.quantity) || 1;

            const itemTotal =
            Number(item.price || 0) * itemQuantity;

            const productUrl = item.url
            ? absoluteURL(item.url)
            : '#';

            return `
            <article class="grouped-offers-selection__item">
                <button
                type="button"
                class="grouped-offers-selection__remove"
                data-grouped-line-action="remove"
                data-variant-id="${escapeHTML(item.variantId)}"
                aria-label="Supprimer ${escapeHTML(item.productTitle)}"
                >
                ×
                </button>

                <a
                href="${escapeHTML(productUrl)}"
                class="grouped-offers-selection__image"
                aria-label="${escapeHTML(item.productTitle)}"
                >
                ${
                    item.image
                    ? `
                        <img
                        src="${escapeHTML(item.image)}"
                        alt="${escapeHTML(item.productTitle)}"
                        loading="lazy"
                        >
                    `
                    : `
                        <div
                        class="grouped-offers-selection__image-placeholder"
                        ></div>
                    `
                }
                </a>

                <div class="grouped-offers-selection__info">
                <a
                    href="${escapeHTML(productUrl)}"
                    class="grouped-offers-selection__title"
                >
                    ${escapeHTML(item.productTitle)}
                </a>

                ${
                    itemVariantLabel
                    ? `
                        <span class="grouped-offers-selection__variant">
                        ${escapeHTML(itemVariantLabel)}
                        <span aria-hidden="true">›</span>
                        </span>
                    `
                    : `
                        <span class="grouped-offers-selection__variant">
                        Taille unique
                        </span>
                    `
                }

                <div class="grouped-offers-selection__price-row">
                    <strong>
                    ${formatMoney(item.price)}
                    </strong>

                    ${
                    itemQuantity > 1
                        ? `
                        <small>
                            Total : ${formatMoney(itemTotal)}
                        </small>
                        `
                        : ''
                    }
                </div>
                </div>

                <div class="grouped-offers-selection__controls">
                <div class="grouped-offers-selection__quantity">
                    <button
                    type="button"
                    data-grouped-line-action="decrease"
                    data-variant-id="${escapeHTML(item.variantId)}"
                    aria-label="Diminuer la quantité"
                    >
                    −
                    </button>

                    <span>
                    ${itemQuantity}
                    </span>

                    <button
                    type="button"
                    data-grouped-line-action="increase"
                    data-variant-id="${escapeHTML(item.variantId)}"
                    aria-label="Augmenter la quantité"
                    >
                    +
                    </button>
                </div>
                </div>
            </article>
            `;
        })
        .join('');
    }

    setText(
        '[data-grouped-subtotal]',
        formatMoney(subtotal)
    );

    setText(
        '[data-grouped-discount]',
        `− ${formatMoney(discount)}`
    );

    setText(
        '[data-grouped-total]',
        formatMoney(total)
    );

    const whatsappButton = root.querySelector(
        '[data-grouped-whatsapp]'
    );

    if (whatsappButton instanceof HTMLButtonElement) {
        whatsappButton.disabled = !offerUnlocked;
    }

    const warning = root.querySelector(
        '[data-grouped-selection-warning]'
    );

    if (warning instanceof HTMLElement) {
        warning.hidden = offerUnlocked;

        warning.textContent =
        `Ajoutez encore ${remainingItems} article${
            remainingItems > 1 ? 's' : ''
        } pour continuer.`;
    }
    }


    function sendWhatsApp() {
      const quantity = totalQuantity();
      const minimumItems = Number(
        config.minimumItems || 3
      );

      if (
        quantity < minimumItems ||
        state.items.length === 0
      ) {
        return;
      }

      const subtotal = getSubtotal();
      const discount = getDiscount(
        quantity,
        subtotal
      );
      const total = Math.max(
        0,
        subtotal - discount
      );

      const messageLines = [
        'Bonjour, je souhaite commander cette offre groupée :',
        '',
      ];

      state.items.forEach((item, index) => {
        const itemVariantLabel =
          variantLabel(item);

        messageLines.push(
          `${index + 1}. ${item.productTitle}`
        );

        if (itemVariantLabel) {
          messageLines.push(
            `Variante : ${itemVariantLabel}`
          );
        }

        messageLines.push(
          `Quantité : ${item.quantity}`
        );

        messageLines.push(
          `Prix unitaire : ${formatMoney(item.price)}`
        );

        messageLines.push(
          `Total article : ${formatMoney(
            Number(item.price) *
              Number(item.quantity)
          )}`
        );

        if (item.url) {
          messageLines.push(
            `Lien : ${absoluteURL(item.url)}`
          );
        }

        messageLines.push('');
      });

      messageLines.push(
        `Nombre total d’articles : ${quantity}`
      );

      messageLines.push(
        `Sous-total : ${formatMoney(subtotal)}`
      );

      messageLines.push(
        `Réduction : -${formatMoney(discount)}`
      );

      messageLines.push(
        `Total à payer : ${formatMoney(total)}`
      );

      const whatsappNumber = String(
        config.whatsappNumber || ''
      ).replace(/\D/g, '');

      if (!whatsappNumber) return;

      const whatsappUrl =
        `https://wa.me/${whatsappNumber}` +
        `?text=${encodeURIComponent(
          messageLines.join('\n')
        )}`;

      window.open(
        whatsappUrl,
        '_blank',
        'noopener'
      );
    }

    function totalQuantity() {
      return state.items.reduce(
        (sum, item) =>
          sum + Number(item.quantity || 0),
        0
      );
    }

    function getSubtotal() {
      return state.items.reduce(
        (sum, item) =>
          sum +
          Number(item.price || 0) *
            Number(item.quantity || 0),
        0
      );
    }

    function getDiscount(quantity, subtotal) {
      const minimumItems = Number(
        config.minimumItems || 3
      );

      if (quantity < minimumItems) {
        return 0;
      }

      const baseDiscount = Number(
        config.baseDiscount || 0
      );

      const extraDiscount = Number(
        config.extraDiscount || 0
      );

      const calculatedDiscount =
        baseDiscount +
        Math.max(
          0,
          quantity - minimumItems
        ) *
          extraDiscount;

      return Math.min(
        calculatedDiscount,
        subtotal
      );
    }

    function saveAndRender() {
      state.items = state.items.filter(
        (item) => Number(item.quantity) > 0
      );

      try {
        localStorage.setItem(
          storageKey,
          JSON.stringify(state.items)
        );
      } catch (error) {
        console.warn(
          'Impossible de mémoriser la sélection.',
          error
        );
      }

      renderAll();
    }

    function setText(selector, value) {
      const element = root.querySelector(selector);

      if (element) {
        element.textContent = value;
      }
    }
  }

  function loadItems(storageKey) {
    try {
      const savedItems = JSON.parse(
        localStorage.getItem(storageKey) || '[]'
      );

      if (!Array.isArray(savedItems)) {
        return [];
      }

      return savedItems
        .filter(
          (item) =>
            item?.variantId &&
            Number(item.quantity) > 0
        )
        .map((item) => ({
          ...item,
          quantity: clamp(
            Number(item.quantity),
            1,
            99
          ),
        }));
    } catch {
      return [];
    }
  }

  function showDialog(dialog) {
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) {
        dialog.showModal();
      }
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog(dialog) {
    if (
      typeof dialog.close === 'function' &&
      dialog.open
    ) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function variantLabel(item) {
    if (
      item.variantTitle &&
      item.variantTitle !== 'Default Title'
    ) {
      return item.variantTitle;
    }

    if (Array.isArray(item.options)) {
      return item.options
        .filter(Boolean)
        .join(' / ');
    }

    return '';
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;

    const formattedAmount = Number.isInteger(amount)
      ? amount.toLocaleString('fr-FR', {
          maximumFractionDigits: 0,
        })
      : amount.toLocaleString('fr-FR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

    return `${formattedAmount} DH`;
  }

  function absoluteURL(url) {
    try {
      return new URL(
        url,
        location.origin
      ).href;
    } catch {
      return url;
    }
  }

  function unique(values) {
    return [...new Set(values)];
  }

  function clamp(value, minimum, maximum) {
    return Math.min(
      maximum,
      Math.max(
        minimum,
        Number(value) || minimum
      )
    );
  }

  function parseJSON(value, fallbackValue) {
    try {
      return JSON.parse(value || '');
    } catch {
      return fallbackValue;
    }
  }

  function escapeHTML(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(),
      { once: true }
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      if (event.target instanceof Element) {
        initAll(event.target);
      }
    }
  );
})();